// KWANKGM04280_近代化資金借入申込 完了
// KWANKGM04250_借入申込希望書兼経営改善資金計画書 完了
import React, { memo } from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import ExaminationModernizationFundsCompleteBody from './ExaminationModernizationFundsCompleteBody';
import BusinessImprovementFinancingPlanExaminationCompleteBody from './BusinessImprovementFinancingPlanExaminationCompleteBody';
import FooterBusinessImprovementFinancingPlan from '../../organisms/FooterBusinessImprovementFinancingPlan';
import ModernizationFundsInputTypeSelectReturn from '../../molecules/ModernizationFundsInputTypeSelectReturn';
import MypageReturn from '../../molecules/MypageReturn';
import { loan_types, modernization_funds_complete_disp_type } from '../../Const';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  reception_id: number;
  status_code?: number;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  is_loading: boolean;
  guarantors_num: number;
  display_status: boolean;
  is_change: boolean;
  is_change_modernization_funds?: boolean;
  api_response_detail: {
    disp_type?: string;
  };
}

const ModernizationFundsExaminationComplete: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  reception_id,
  status_code,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  is_loading,
  guarantors_num,
  display_status,
  is_change,
  is_change_modernization_funds,
  api_response_detail,
}) => {
  // URLパラメータに商品IDを取得
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');

  // 表示パターン
  const disp_type = api_response_detail.disp_type ?? sessionStorage.getItem('disp_type');

  // マイページへ戻るボタンの表示フラグ
  const is_hidden_return_mypage_button =
    (item_id === loan_types.modernization_funds && is_change_modernization_funds) ||
    (item_id === loan_types.business_improvement_financing_plan &&
      disp_type === modernization_funds_complete_disp_type.change_borrowing_application);

  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      {/* ローン種類が借入申込希望書兼経営改善資金計画書の場合は、借入申込希望書兼経営改善資金計画書 完了を表示 */}
      {item_id === loan_types.business_improvement_financing_plan ? (
        <>
          <BusinessImprovementFinancingPlanExaminationCompleteBody disp_type={disp_type} />
          <FooterBusinessImprovementFinancingPlan
            reception_cd={reception_cd}
            reception_id={reception_id}
            status={status_code}
            disp_type={disp_type}
          />
        </>
      ) : (
        <ExaminationModernizationFundsCompleteBody
          reception_cd={reception_cd}
          is_decline={false}
          is_change={is_change}
          is_change_modernization_funds={is_change_modernization_funds}
          guarantors_num={guarantors_num}
          disp_type={disp_type}
          reception_id={reception_id}
          status={status_code}
        />
      )}
      <ModernizationFundsInputTypeSelectReturn
        reception_cd={reception_cd}
        reception_id={reception_id}
        is_change_modernization_funds={is_change_modernization_funds}
        disp_type={disp_type}
        item_id={item_id}
      />
      {/* ローン種類が近代化資金、借入申込希望書兼経営改善資金計画書で変更中の場合は非表示 */}
      {is_hidden_return_mypage_button ? <></> : <MypageReturn is_staff={false} />}

      <LoadingModal show={is_loading} />
    </>
  );
};

export default memo(ModernizationFundsExaminationComplete);
